/**
 * Created by cuigl on 08/04/2019.
 */
import { Reducer } from '@ekuaibao/store'
import key from './key'
import { showMessage } from '@ekuaibao/show-util'

const reducer = new Reducer(key.ID, {
  countryList: [{ code: '86', name: i18n.get('中国') }],
  corporationsList: [],
  externalCorpList: []
})

reducer.handle(key.SEND_CAPTCHA, (state, action) => {
  return { ...state }
})

reducer.handle(key.SEND_VOICE_CAPTCHA, (state, action) => {
  return { ...state }
})
reducer.handle(key.SEND_REG_VOICE_CAPTCHA, (state, action) => {
  return { ...state }
})
reducer.handle(key.CORPORATIONS, (state, action) => {
  return { ...state }
})

reducer.handle(key.CORPORATIONS_COUNT, (state, action) => {
  const corporationsList = action.payload.items
  // 此处加上外部协助企业信息
  const externalCorpList = action.payload?.externalItems
  return { ...state, corporationsList, externalCorpList }
})

reducer.handle(key.GET_COUNTRY, (state, action) => {
  const countryList = action.payload.items
  return { ...state, countryList }
})

reducer.handle(key.BASIC_ACCOUNT, (state, action) => {
  return { ...state }
})

reducer.handle(key.PRO_ACCOUNT, (state, action) => {
  return { ...state }
})
reducer.handle(key.SMS_ACCOUNT, (state, action) => {
  return { ...state }
})
reducer.handle(key.LDAP_ACCOUNT, (state, action) => {
  if(action.error){
    showMessage.error(action.payload?.msg || action.payload?.errorMessage)
  }
  return { ...state }
})

reducer.handle(key.GET_CAPTCHA, (state, action) => {
  return { ...state }
})

reducer.handle(key.CHECK_CAPTCHA, (state, action) => {
  return { ...state }
})

reducer.handle(key.USER_REGISTER, (state, action) => {
  return { ...state }
})

reducer.handle(key.FORGET_UPDATE_PASSWORD, (state, action) => {
  return { ...state }
})

reducer.handle(key.CREATE_ORG, (state, action) => {
  return { ...state }
})

reducer.handle(key.GENERATE_INVITE_LINKS, (state, action) => {
  return { ...state }
})

reducer.handle(key.BY_CODE_JOIN_ENTERPRISE, (state, action) => {
  return { ...state }
})

reducer.handle(key.EXIT_LOGON, (state, action) => {
  return { ...state }
})
reducer.handle(key.GET_READ, (state, action) => {
  return { ...state }
})
reducer.handle(key.CHECK_CONFIRM, (state, action) => {
  return { ...state }
})

reducer.handle(key.CSX_LOGOUT, (state, action) => {
  return { ...state }
})
export default reducer
